import React from "react";
import Fade from "./Fade";
import CentralLoader from "../uikit/CentralLoader";
import PropTypes from "prop-types";
FullPageLoader.propTypes = {
    open: PropTypes.bool
};
export default function FullPageLoader(param) {
    var _param_open = param.open, open = _param_open === void 0 ? true : _param_open;
    return /*#__PURE__*/ React.createElement(Fade, {
        in: open,
        initiallyShown: true,
        fadeSpeed: 300
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed z-50 h-screen w-full"
    }, /*#__PURE__*/ React.createElement(CentralLoader, null)));
}
